module.exports = __webpack_public_path__ + "bc170a9601ad03d04e1ef019ece520ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/ueberfremdung.svg
// module id = 10
// module chunks = 0